import React from "react";
import "./TNC.css";
import {
  FaCalendarAlt,
  FaFileContract,
  FaUserCheck,
  FaUserShield,
  FaMusic,
  FaCopyright,
  FaMoneyBillWave,
  FaBan,
  FaGlobe,
  FaCreditCard,
  FaUndoAlt,
  FaLightbulb,
  FaExclamationTriangle,
  FaGavel,
  FaShieldAlt,
  FaInfoCircle,
  FaFileSignature,
  FaBalanceScale,
  FaSyncAlt,
  FaEnvelope,
  FaPhoneAlt,
} from "react-icons/fa";
import { Container } from "react-bootstrap";

const TNC = () => {
  return (
    <div className="tnc-container">
      <Container>
        {/* Background glowing elements */}
        {/* <div className="glow-circle pink-glow top-left"></div>
      <div className="glow-circle blue-glow top-right"></div>
      <div className="glow-circle purple-glow center-left"></div>
      <div className="glow-circle blue-glow bottom-right"></div> */}

        <div className="tnc-wrapper">
          {/* Header Section */}
          <div className="tnc-header">
            <div className="brand-logo">
              <span className="logo-text-white">F</span>
              <span className="logo-text-pink">T</span>
              <span className="logo-text-white">unes</span>
            </div>
            <h1 className="main-title">
              <span className="text-yellow">Terms &</span>{" "}
              <span className="text-pink">Conditions</span>
            </h1>
            {/* <div className="last-updated">
            <FaCalendarAlt className="calendar-icon" />
            <span>Last Updated: [Insert Date]</span>
          </div> */}
            <p className="intro-text">
              Welcome to FT Tunes ("FT Tunes", "we", "our", or "us"). These
              Terms & Conditions govern your access to and use of our website,
              services, products, music distribution platform, and related
              features available through www.fttunes.com (collectively, the
              "Services").
            </p>
            <p className="intro-text mt-3">
              By creating an account, accessing our website, or using any FT
              Tunes service, you agree to be legally bound by these Terms &
              Conditions. If you do not agree with any part of these Terms,
              please do not use our Services.
            </p>
          </div>

          {/* Section 1 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number purple-gradient">1</span>
              <FaFileContract className="section-icon-inline mr-2 text-purple" />{" "}
              About FT Tunes
            </h2>
            <p className="section-text">
              FT Tunes is a music distribution and digital content management
              platform that helps artists, labels, producers, and rights holders
              distribute and monetize their music across digital streaming
              platforms, social media platforms, and online stores worldwide.
            </p>
          </div>

          {/* Section 2 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number orange-gradient">2</span>
              <FaUserCheck className="section-icon-inline mr-2 text-orange" />{" "}
              Eligibility
            </h2>
            <p className="section-text mb-2">To use FT Tunes Services:</p>
            <ul className="custom-list mb-3">
              <li>You must be at least 18 years old; or</li>
              <li>
                If you are between 13 and 18 years old, you may only use the
                Services under the supervision of a parent or legal guardian.
              </li>
              <li>
                You must have the legal authority to enter into binding
                agreements.
              </li>
              <li>
                You must provide accurate, complete, and current registration
                information.
              </li>
            </ul>
            <p className="section-text ">
              FT Tunes reserves the right to refuse service, suspend accounts,
              or terminate access if false information is provided.
            </p>
          </div>

          {/* Section 3 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number pink-gradient">3</span>
              <FaUserShield className="section-icon-inline mr-2 text-pink" />{" "}
              Account Registration
            </h2>
            <p className="section-text mb-2">
              To access certain Services, you may be required to create an
              account. You agree to:
            </p>
            <ul className="custom-list mb-3">
              <li>Maintain the confidentiality of your login credentials.</li>
              <li>
                Be responsible for all activities conducted through your
                account.
              </li>
              <li>
                Notify FT Tunes immediately of any unauthorized access or
                security breach.
              </li>
            </ul>
            <p className="section-text ">
              FT Tunes is not liable for losses resulting from unauthorized
              account access caused by your failure to secure your credentials.
            </p>
          </div>

          {/* Section 4 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number blue-gradient">4</span>
              <FaMusic className="section-icon-inline mr-2 text-blue" /> Music
              Distribution Services
            </h2>
            <p className="section-text mb-2">
              FT Tunes provides music distribution services to eligible artists
              and rights holders. By submitting content, you confirm that:
            </p>
            <ul className="custom-list mb-3">
              <li>
                You own or control all rights necessary to distribute the
                content.
              </li>
              <li>
                The content does not infringe any copyright, trademark,
                publicity, privacy, or other rights of any third party.
              </li>
              <li>
                All metadata, credits, artist names, songwriter information, and
                release details are accurate.
              </li>
              <li>
                You have obtained all required permissions, licenses, and
                clearances.
              </li>
            </ul>
            <p className="section-text ">
              Submission of content does not guarantee acceptance by digital
              streaming platforms (DSPs).
            </p>
          </div>

          {/* Section 5 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number red-gradient">5</span>
              <FaCopyright className="section-icon-inline mr-2 text-red" />{" "}
              Content Ownership
            </h2>
            <p className="section-text mb-2">
              You retain ownership of your music and intellectual property. By
              using FT Tunes Services, you grant FT Tunes a non-exclusive,
              worldwide license to:
            </p>
            <div className="list-grid-2 mb-3">
              <div className="list-item-bullet">Store your content</div>
              <div className="list-item-bullet">Distribute your content</div>
              <div className="list-item-bullet">
                Deliver your content to partner platforms
              </div>
              <div className="list-item-bullet">
                Monetize your content where applicable
              </div>
              <div className="list-item-bullet">
                Promote your content for service-related purposes
              </div>
            </div>
            <p className="section-text ">
              This license remains effective for as long as your content remains
              active within our distribution network.
            </p>
          </div>

          {/* Section 6 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number green-gradient">6</span>
              <FaMoneyBillWave className="section-icon-inline mr-2 text-green" />{" "}
              Royalty Payments
            </h2>
            <p className="section-text mb-2">
              FT Tunes will collect royalties from partner platforms and
              distribute eligible earnings to users according to the applicable
              plan and payment terms. Royalty payments are subject to:
            </p>
            <div className="list-grid-2 mb-3">
              <div className="list-item-bullet">
                Platform reporting schedules
              </div>
              <div className="list-item-bullet">Revenue verification</div>
              <div className="list-item-bullet">Fraud detection reviews</div>
              <div className="list-item-bullet">
                Applicable taxes and deductions
              </div>
              <div className="list-item-bullet">Minimum payout thresholds</div>
            </div>
            <p className="section-text ">
              FT Tunes reserves the right to withhold payments where fraudulent
              activity, copyright disputes, or policy violations are suspected.
            </p>
          </div>

          {/* Section 7 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number red-gradient">7</span>
              <FaBan className="section-icon-inline mr-2 text-red" /> Prohibited
              Content
            </h2>
            <p className="section-text mb-2">
              Users may not upload, distribute, or monetize content that:
            </p>
            <ul className="custom-list red-bullets mb-3">
              <li>Infringes copyrights or intellectual property rights</li>
              <li>Contains unauthorized samples or recordings</li>
              <li>Includes misleading artist names or metadata</li>
              <li>Contains hate speech or unlawful content</li>
              <li>Promotes violence, terrorism, or criminal activities</li>
              <li>Contains malicious software or harmful code</li>
              <li>Violates any applicable law or platform policy</li>
            </ul>
            <p className="section-text ">
              FT Tunes reserves the right to reject, remove, suspend, or
              terminate content and accounts that violate these provisions.
            </p>
          </div>

          {/* Section 8 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number blue-gradient">8</span>
              <FaGlobe className="section-icon-inline mr-2 text-blue" />{" "}
              Third-Party Platforms
            </h2>
            <p className="section-text mb-2">
              FT Tunes distributes content to third-party platforms including
              but not limited to:
            </p>
            <div className="tags-container mb-3">
              <span className="platform-tag">Spotify</span>
              <span className="platform-tag">Apple Music</span>
              <span className="platform-tag">YouTube Music</span>
              <span className="platform-tag">Amazon Music</span>
              <span className="platform-tag">JioSaavn</span>
              <span className="platform-tag">Instagram</span>
              <span className="platform-tag">Facebook</span>
              <span className="platform-tag">TikTok</span>
              <span className="platform-tag">Deezer</span>
              <span className="platform-tag">
                Other digital streaming services
              </span>
            </div>
            <p className="section-text mb-2">
              Each platform maintains its own policies and guidelines. FT Tunes
              cannot guarantee:
            </p>
            <ul className="custom-list mb-3">
              <li>Approval of releases</li>
              <li>Placement in playlists</li>
              <li>Streaming numbers</li>
              <li>Revenue generation</li>
              <li>Platform availability</li>
            </ul>
            <p className="section-text ">
              Platform decisions remain solely under the control of the
              respective service providers.
            </p>
          </div>

          {/* Grid for smaller sections */}
          <div className="cards-grid-2">
            {/* Section 9 */}
            <div className="policy-section card-gradient-border">
              <h2 className="section-title">
                <span className="section-number orange-gradient">9</span>
                <FaCreditCard className="section-icon-inline mr-2 text-orange" />{" "}
                Subscription Plans & Fees
              </h2>
              <p className="section-text mb-2">
                Certain FT Tunes Services may require payment. By purchasing any
                plan, you agree that:
              </p>
              <ul className="custom-list mb-3">
                <li>Fees are charged according to the selected plan.</li>
                <li>
                  Subscription fees may renew automatically unless canceled.
                </li>
                <li>Pricing may change at any time.</li>
                <li>
                  Taxes, government levies, and payment gateway charges may
                  apply.
                </li>
              </ul>
              <p className="section-text ">
                All purchases are subject to our Refund Policy.
              </p>
            </div>

            {/* Section 10 */}
            <div className="policy-section card-gradient-border">
              <h2 className="section-title">
                <span className="section-number pink-gradient">10</span>
                <FaUndoAlt className="section-icon-inline mr-2 text-pink" />{" "}
                Refund Policy
              </h2>
              <p className="section-text mb-3">
                Refund requests are governed by our Refund Policy available on
                the website.
              </p>
              <p className="section-text ">
                Due to the digital nature of our Services, most distribution and
                subscription fees are non-refundable once processing has begun.
              </p>
            </div>
          </div>

          {/* Section 11 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number purple-gradient">11</span>
              <FaLightbulb className="section-icon-inline mr-2 text-purple" />{" "}
              Intellectual Property Rights
            </h2>
            <p className="section-text mb-2">
              All trademarks, logos, software, designs, content, branding,
              graphics, and materials displayed on the FT Tunes website are the
              property of FT Tunes or its licensors. You may not:
            </p>
            <div className="tags-container mb-0">
              <span className="action-tag">Copy</span>
              <span className="action-tag">Modify</span>
              <span className="action-tag">Reverse engineer</span>
              <span className="action-tag">Reproduce</span>
              <span className="action-tag">Redistribute</span>
              <span className="action-tag">Sell</span>
              <span className="action-tag">License</span>
            </div>
            <p className="section-text  mt-3">
              any FT Tunes intellectual property without prior written consent.
            </p>
          </div>

          {/* Section 12 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number red-gradient">12</span>
              <FaExclamationTriangle className="section-icon-inline mr-2 text-red" />{" "}
              Prohibited Activities
            </h2>
            <p className="section-text mb-2">You agree not to:</p>
            <ul className="custom-list red-bullets mb-3">
              <li>Use bots, scrapers, or automated systems on the platform.</li>
              <li>Attempt unauthorized access to FT Tunes systems.</li>
              <li>Upload malicious software or harmful code.</li>
              <li>Manipulate streams, royalties, or reporting systems.</li>
              <li>Engage in fraudulent activity.</li>
              <li>Interfere with the operation of the Services.</li>
            </ul>
            <p className="section-text ">
              Violations may result in immediate suspension or termination.
            </p>
          </div>

          {/* Section 13 */}
          <div className="policy-section card-gradient-border">
            <h2 className="section-title">
              <span className="section-number red-gradient">13</span>
              <FaGavel className="section-icon-inline mr-2 text-red" /> Account
              Suspension & Termination
            </h2>
            <p className="section-text mb-2">
              FT Tunes reserves the right to suspend or terminate any account at
              its sole discretion if:
            </p>
            <ul className="custom-list red-bullets mb-3">
              <li>These Terms are violated.</li>
              <li>Fraudulent activity is detected.</li>
              <li>Copyright infringement claims arise.</li>
              <li>Payment disputes occur.</li>
              <li>Platform abuse is identified.</li>
            </ul>
            <p className="section-text ">
              Upon termination, FT Tunes may remove content and discontinue
              Services without liability.
            </p>
          </div>

          {/* Section 14 & 15 Grid */}
          <div className="cards-grid-2">
            {/* Section 14 */}
            <div className="policy-section card-gradient-border">
              <h2 className="section-title">
                <span className="section-number orange-gradient">14</span>
                <FaShieldAlt className="section-icon-inline mr-2 text-orange" />{" "}
                Disclaimer of Warranties
              </h2>
              <p className="section-text mb-2">
                The FT Tunes website and Services are provided on an "AS IS" and
                "AS AVAILABLE" basis. FT Tunes does not guarantee:
              </p>
              <ul className="custom-list mb-3">
                <li>Continuous availability</li>
                <li>Error-free operation</li>
                <li>Uninterrupted access</li>
                <li>Compatibility with all devices or software</li>
              </ul>
              <p className="section-text ">
                Your use of the Services is at your own risk.
              </p>
            </div>

            {/* Section 15 */}
            <div className="policy-section card-gradient-border">
              <h2 className="section-title">
                <span className="section-number pink-gradient">15</span>
                <FaInfoCircle className="section-icon-inline mr-2 text-pink" />{" "}
                Limitation of Liability
              </h2>
              <p className="section-text mb-2">
                To the fullest extent permitted by law, FT Tunes shall not be
                liable for:
              </p>
              <ul className="custom-list mb-3">
                <li>Loss of profits</li>
                <li>Loss of revenue</li>
                <li>Loss of data</li>
                <li>Loss of business opportunities</li>
                <li>Indirect or consequential damages</li>
              </ul>
              <p className="section-text ">
                arising from your use of the Services. In any event, FT Tunes'
                total liability shall not exceed the amount paid by the user to
                FT Tunes during the preceding six (6) months.
              </p>
            </div>
          </div>

          {/* Section 16 & 17 Grid */}
          <div className="cards-grid-2">
            {/* Section 16 */}
            <div className="policy-section card-gradient-border">
              <h2 className="section-title">
                <span className="section-number blue-gradient">16</span>
                <FaFileSignature className="section-icon-inline mr-2 text-blue" />{" "}
                Indemnification
              </h2>
              <p className="section-text mb-2">
                You agree to indemnify and hold harmless FT Tunes, its
                directors, employees, affiliates, partners, and representatives
                from any claims, losses, liabilities, damages, costs, or
                expenses arising from:
              </p>
              <ul className="custom-list mb-0">
                <li>Your content</li>
                <li>Your use of the Services</li>
                <li>Violation of these Terms</li>
                <li>Infringement of third-party rights</li>
              </ul>
            </div>

            {/* Section 17 */}
            <div className="policy-section card-gradient-border">
              <h2 className="section-title">
                <span className="section-number purple-gradient">17</span>
                <FaUserShield className="section-icon-inline mr-2 text-purple" />{" "}
                Privacy
              </h2>
              <p className="section-text mb-3">
                Your use of FT Tunes is also governed by our Privacy Policy.
              </p>
              <p className="section-text  mb-0">
                By using our Services, you consent to the collection and
                processing of information as described in our Privacy Policy.
              </p>
            </div>
          </div>

          {/* Section 18 & 19 Grid */}
          <div className="cards-grid-2">
            {/* Section 18 */}
            <div className="policy-section card-gradient-border">
              <h2 className="section-title">
                <span className="section-number green-gradient">18</span>
                <FaBalanceScale className="section-icon-inline mr-2 text-green" />{" "}
                Governing Law & Jurisdiction
              </h2>
              <p className="section-text mb-3">
                These Terms shall be governed by and construed in accordance
                with the laws of India.
              </p>
              <p className="section-text mb-3">
                Any disputes arising from these Terms shall first be attempted
                to be resolved through mutual discussions.
              </p>
              <p className="section-text  mb-0">
                If unresolved, such disputes shall be subject to the exclusive
                jurisdiction of the courts located in New Delhi, India.
              </p>
            </div>

            {/* Section 19 */}
            <div className="policy-section card-gradient-border">
              <h2 className="section-title">
                <span className="section-number orange-gradient">19</span>
                <FaSyncAlt className="section-icon-inline mr-2 text-orange" />{" "}
                Changes to Terms
              </h2>
              <p className="section-text mb-3">
                FT Tunes reserves the right to update or modify these Terms &
                Conditions at any time.
              </p>
              <p className="section-text mb-3">
                Updated versions will be posted on this page with the revised
                effective date.
              </p>
              <p className="section-text  mb-0">
                Continued use of the Services after updates constitutes
                acceptance of the revised Terms.
              </p>
            </div>
          </div>

          {/* Section 20 - Contact */}
          <div className="policy-section transparent-bg mb-0 pb-0">
            <h2 className="section-title">
              <span className="section-number pink-gradient">20</span> Contact
              Information
            </h2>

            <div className="contact-grid-tnc">
              <div className="contact-address-box card-gradient-border">
                <h3 className="address-title">FT Tunes</h3>
                <p className="address-line">A2, 2nd Floor, Palam Dabri Road,</p>
                <p className="address-line">Mahavir Enclave, Dwarka,</p>
                <p className="address-line">New Delhi – 110045, India</p>
              </div>

              <div className="contact-details-box">
                <div className="contact-item">
                  <div className="contact-icon purple-bg">
                    <FaEnvelope />
                  </div>
                  <div>
                    <div className="contact-label">Email</div>
                    <div className="contact-value">music@fttunes.com</div>
                  </div>
                </div>
                <div className="contact-item mt-4">
                  <div className="contact-icon red-bg">
                    <FaGlobe />
                  </div>
                  <div>
                    <div className="contact-label">Website</div>
                   aihrefv className="contact-value">www.fttunes.comaiv>
                  </div>
                </div>
                <div className="contact-item mt-4">
                  <div className="contact-icon orange-bg">
                    <FaPhoneAlt />
                  </div>
                  <div>
                    <div className="contact-label">Phone</div>
                    <div className="contact-value">+91 8084 18 7424</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default TNC;
